import React,{useEffect,useState} from 'react';
import { Row } from 'reactstrap';
import axios from 'axios';

function DriveInfo() {

    const myinfo = JSON.parse(window.sessionStorage.result);
    const { u_login_id,u_nick,u_type } = myinfo;
    let field;
    let represent;
    if(u_type == '일반고객'){
        field = 'c.co_user_id';
        represent = 'rep.represent';
    }else if(u_type == '카마스터'){
        field = 'c.co_user_id2';
        represent = 'rep.represent2';
    }
    const [data, setData] = useState([]);
    let obj = {
        u_id:u_login_id,
        field:field,
        represent:represent
    }
    useEffect(() => {
        
      const fetchData = async () => {
        axios.post('https://abys-service.co.kr:3001/rep_car/main_info',obj).then(function(res){
            setData(res.data);
        });
        
      };

      fetchData();

    }, []);

    console.log('data :', data);
    
    
    const mySize = {
        marginTop:"30px",
        marginBottom:"80px"
    }
    
    return (
        <div className="mt-5">
            <h3 className="ml-5 mt-5 mb-3 font-weight-bold">차량정보</h3>
            <Row className="mb-3">
                <div className="col-5">
                    <div>모델명</div>
                    <div>년식</div>
                    <div>출고일</div>
                    <div>차량번호</div>
                    <div>차량APP등록일</div>
                    <div>출고 색상</div>
                </div>
                <div className="col-7">
                    {
                        data.map(v =><>
                        <div id="modelName">{v.u_car_name}</div>
                        <div id="yearTxt">{v.u_car_age}</div>
                        <div id="carDate">{v.u_car_date}</div>
                        <div id="carNum">{u_type=== '일반고객' ? v.u_car_number :<span>-</span>}</div>
                        <div>{v.u_app_date}</div>
                        <div id="carColor">{v.u_car_color}</div>
                        </>)
                    }
                </div>
            </Row>
        </div>
    );
}



export default DriveInfo;